export const isAllowed = (user, rights) => {
  if (!user) {
    return false;
  } else {
    return rights.some(right => user.permissions.includes(right));
  }
};